(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-info-tabs')) {
    class ProductInfoTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index));
          tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
        });
      }

      selectTab(index, { focusTab = true } = {}) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[i].hidden = !selected;
        });

        if (focusTab) this.tabs[index].focus();
      }

      handleKeydown(event, index) {
        const { key } = event;
        let newIndex = null;

        if (key === 'ArrowRight' || key === 'ArrowDown') {
          newIndex = (index + 1) % this.tabs.length;
        } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
          newIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        } else if (key === 'Home') {
          newIndex = 0;
        } else if (key === 'End') {
          newIndex = this.tabs.length - 1;
        }

        if (newIndex !== null) {
          event.preventDefault();
          this.selectTab(newIndex);
        }
      }
    }

    customElements.define('product-info-tabs', ProductInfoTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
